import { Tooltip } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"

import { color } from "../../atoms/colors"

export const LocationTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "rgba(255,255,255,0.9)",
    color: `${color.gray[900]}`,
    fontSize: 14,
    fontWeight: "normal",
    boxShadow: theme.shadows[3],
    fontFamily: "tenon, sans-serif",
    padding: 15,
  },
  arrow: {
    color: "rgba(255,255,255,0.9)",
  },
}))(Tooltip)

export const LocationTooltipMap = withStyles((theme) => ({
  tooltip: {
    backgroundColor: `${color.primary[350]}`,
    color: `${color.common.white}`,
    fontSize: 14,
    boxShadow: theme.shadows[3],
    fontFamily: "tenon, sans-serif",
    padding: 7,
  },
}))(Tooltip)
